import React from 'react';
import { newsArticles } from '../../data/news';
import CyberNewsListTemplate from './CyberNewsListTemplate';

const CyberNewsCrimeList: React.FC = () => {
  return <CyberNewsListTemplate 
    category="event" 
    title="Evènements - Cybersécurité"
    description="Les prochains évènements de l'écosystème cybersécurité"
  />;
};

export default CyberNewsCrimeList; 